<mat-card-content *ngIf="isPrintMode" id="print-view">
    <section *ngFor="let item of report.reportItems; index as i" id="chart-{{i}}">
        <ng-container *ngFor="let variation of item.variations">
            <ng-container *ngIf="variation.code === 'chart'">
                <app-report-chart [variation]="variation"></app-report-chart>
            </ng-container>
        </ng-container>
    </section>
    <section *ngFor="let item of report.reportItems; index as i" id="table-{{i}}">
        <ng-container *ngFor="let variation of item.variations">
            <ng-container *ngIf="variation.code === 'table'">
                <app-report-datatable [variation]="variation"></app-report-datatable>
            </ng-container>
        </ng-container>
    </section>

    <app-report-custom *ngFor="let report of customReports"
        [report]="report" [selMode]="selMode"></app-report-custom>

    <div class="print-mask">
        <h3>{{ 'reports.exportMessage.summary' | translate }}</h3>
        <mat-spinner [diameter]="35" color="accent" ></mat-spinner>
    </div>
</mat-card-content>
